import logo_mynextID from "../../img/logo_mynextID.svg";
import { Link, useNavigate } from "react-router-dom";

let pathname = window.location.pathname;
if (pathname === "" || pathname === "/") {
  pathname = "/";
}

interface HeaderNoAuthProps {
  onCurrent?: (path: string) => void;
}

function HeaderNoAuth(props: HeaderNoAuthProps) {
  const navigate = useNavigate();

  return (
    <>
      {/*<header className="site-header">
        <img
          id="logo-basic"
          src={logo_mynextID}
          alt="logo"
          className="logo clickable"
          onClick={() => {
            navigate("/");
          }}
        />
        </header>*/}

      <nav className="navbar m-show">
 
        <Link to="/">
          <img src="img/logo_mynextID.svg" alt="" className="logo m-show" />
        </Link>

        <div className="navbar__right site-navigation "></div>
      </nav>
    </>
  );
}

export default HeaderNoAuth;
